import "./Site.html";
import "./Site.scss";

import "../AlarmCentralInformation/AlarmCentralInformationComponent";
import "../AlarmEvents/AlarmEventsComponent";
import "../ConfigurationGroups/ConfigurationGroupsComponent";
import "../ContactInformation/ContactInformationComponent";
import "../DataPolicy/DataPolicyComponent";
import "../GuardCompanies/GuardCompaniesComponent";
import "../Hardware/HardwareComponent";
import "../LatestEvents/LatestEventsComponent";
import "../LatestSupervisions/LatestSupervisionsComponent";
import "../Map/MapComponent";
import "../Notes/NotesComponent";
import "../Persons/PersonsComponent";
import "../SiteInformation/SiteInformationComponent";
import "../TeamList/TeamListComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import SiteComponentController from "./SiteComponentController";

export class SiteComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            siteId: "<",
        };
        this.controller = SiteComponentController;
        this.templateUrl = "/App/Components/Site/Overview/Dashboard/Site.html";
    }
}

module("mmManagePortal").component("mmSite", new SiteComponent());
